export default {"src":"__ASTRO_ASSET_IMAGE__DX9Os03t__","width":48,"height":48,"format":"svg"}